import {Query, Store, StoreConfig} from "@datorama/akita"
import {ApiClient, ApiClientResult} from "app/Interface/Api/Client/ApiClient"
import produce from "immer"

interface ClientInitState extends ApiClientResult {
  loading: undefined | boolean
  edit: undefined | ApiClient
  update: undefined | string[]
}

const clientInitState = (): ClientInitState => {
  return {
    loading: undefined,
    id: '',
    name: '',
    clientModules: [],
    settingsDefaults: [],
    users: [],

    address: [],
    emailAddress: [],
    bankAccounts: [],
    businessNumbers: null,

    defaultInvoicePrintTemplate: null,
    invoiceNumberSetting: null,

    edit: undefined,
    update: undefined,
  }
}

@StoreConfig({name: 'root.client', resettable: true, producerFn: produce})
class ClientStore extends Store<ClientInitState> {
  constructor() {
    super(clientInitState())
  }
}

export const rootClientStore = new ClientStore()

class ClientQuery extends Query<ClientInitState> {
  constructor(protected store: ClientStore) {
    super(store)
  }
}

export const rootClientQuery = new ClientQuery(rootClientStore)
